import { z } from 'zod';

export const changePasswordInputSchema = z.object({
  current_password: z
    .string()
    .min(10, 'パスワードは10文字以上で入力してください')
    .regex(/[A-Z]/, 'パスワードには少なくとも1つの英大文字を含めてください')
    .regex(/[a-z]/, 'パスワードには少なくとも1つの英小文字を含めてください')
    .regex(/[0-9]/, 'パスワードには少なくとも1つの数字を含めてください')
    .regex(
      /[!@#$%^&*()_+\-=[\]{}|']/,
      "パスワードには少なくとも1つの記号（!@#$%^&*()_+-=[]{}|'）を含めてください",
    ),
  password: z
    .string()
    .min(10, 'パスワードは10文字以上で入力してください')
    .regex(/[A-Z]/, 'パスワードには少なくとも1つの英大文字を含めてください')
    .regex(/[a-z]/, 'パスワードには少なくとも1つの英小文字を含めてください')
    .regex(/[0-9]/, 'パスワードには少なくとも1つの数字を含めてください')
    .regex(
      /[!@#$%^&*()_+\-=[\]{}|']/,
      "パスワードには少なくとも1つの記号（!@#$%^&*()_+-=[]{}|'）を含めてください",
    ),
  confirm_password: z.string().min(1, 'パスワードを再度入力してください'),
});
export type ChangePasswordInput = z.infer<typeof changePasswordInputSchema>;
